import './polyfills';
import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import {ThemeProvider} from "@material-ui/core/styles";
import theme from "./styles/theme";

import App from "./App";

import Clarity from '@microsoft/clarity';

const projectId = "t37vf98d05"

Clarity.init(projectId);

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
          <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
